import React, { memo } from 'react';

type SelectableButtonProps = {
    id: string;
    onClicked: (selected: boolean) => void;
    selected: boolean;
    text: string;
};

const SelectableButton = memo(
    SelectableButtonMemo,
    (prevProps, currentProps) => {
        return (
            prevProps.selected === currentProps.selected &&
            prevProps.text === currentProps.text
        );
    }
);

function SelectableButtonMemo({
    id,
    onClicked,
    selected,
    text
}: SelectableButtonProps): JSX.Element {
    const onClick = () => {
        const selctedValue = !selected;
        onClicked(selctedValue);
    };

    const buttonStyle = selected ? 'btn btn-select active' : 'btn btn-select';

    return (
        <button id={id} name={id} className={buttonStyle} onClick={onClick}>
            {text}
        </button>
    );
}

export default SelectableButton;
